import { Column } from '../../../../../components/tables/basicTable/BasicTable.types';
import { truncateWithEllipsis } from '../../../../../utils/commonUtils';
import { TEXT_CONTENT } from '../../../../../utils/constants';
import {
  DATE_FORMAT,
  isValidDate,
  toDisplayDate,
} from '../../../../../utils/date';
import { toFixedDigit } from '../../../../../utils/number';

export const summaryTableColumns: Column[] = [
  {
    field: 'totalPhysician',
    sortable: false,
    headerName: TEXT_CONTENT.TOTAL_PHYSICIAN_HOURS,
  },
  {
    field: 'totalApp',
    sortable: false,
    headerName: TEXT_CONTENT.TOTAL_APP_HOURS,
  },
  {
    field: 'overallTotal',
    sortable: false,
    headerName: TEXT_CONTENT.TOTAL_APP_PHY_HOURS,
  },
  {
    field: 'totalCorrectedPatientsPerHour',
    sortable: false,
    headerName: TEXT_CONTENT.TOTAL_CORRECTED_APP_PHY_HRS,
    renderCell: ({ row }) => {
      return toFixedDigit(row?.['totalPhysician'] + row?.['totalApp'] / 2);
    },
  },
];

export function getScenarioDetailColumns(isShort: boolean = false) {
  let columns: Column[] = [
    {
      field: 'shiftStartDateHour',
      headerName: isShort
        ? `${truncateWithEllipsis(isShort, TEXT_CONTENT.START, 5)}`
        : TEXT_CONTENT.SHIFT_START,
      toolTipLabel: TEXT_CONTENT.SHIFT_START,
      sortable: !isShort,
      width: isShort ? '25%' : '20%',
      renderCell: ({ value }) =>
        value && isValidDate(value)
          ? toDisplayDate(
              value,
              isShort ? DATE_FORMAT.DAY_WITH_HR : DATE_FORMAT.DAY_WITH_TIME
            )
          : '',
    },
    {
      field: 'shiftEndDateHour',
      headerName: isShort
        ? `${truncateWithEllipsis(isShort, TEXT_CONTENT.END, 3)}`
        : TEXT_CONTENT.SHIFT_END,
      toolTipLabel: TEXT_CONTENT.SHIFT_END,
      sortable: !isShort,
      width: isShort ? '25%' : '20%',
      renderCell: ({ value }) =>
        value && isValidDate(value)
          ? toDisplayDate(
              value,
              isShort ? DATE_FORMAT.DAY_WITH_HR : DATE_FORMAT.DAY_WITH_TIME
            )
          : '',
    },
    {
      field: 'providerType',
      sortable: !isShort,
      headerName: isShort
        ? `${truncateWithEllipsis(isShort, TEXT_CONTENT.PROVIDER, 8)}`
        : TEXT_CONTENT.PROVIDER_TYPE,
      toolTipLabel: TEXT_CONTENT.PROVIDER_TYPE,
      width: '20%',
      renderCell: ({ value, row }) =>
        isShort
          ? `${value?.slice(0, 3)} (${row?.['providerCount'] || 1})`
          : value,
    },
    {
      field: 'shiftLength',
      sortable: !isShort,
      headerName: isShort
        ? `${truncateWithEllipsis(isShort, TEXT_CONTENT.HOURS_SHORT, 3)}`
        : TEXT_CONTENT.SHIFT_LENGTH,
      toolTipLabel: TEXT_CONTENT.SHIFT_LENGTH,
      width: isShort ? '5%' : '20%',
    },
  ];
  if (!isShort)
    columns.push({
      field: 'providerCount',
      sortable: !isShort,
      headerName: isShort
        ? `${truncateWithEllipsis(isShort, TEXT_CONTENT.COUNT, 5)}`
        : TEXT_CONTENT.PROVIDER_COUNT,
      toolTipLabel: TEXT_CONTENT.PROVIDER_COUNT,
      width: isShort ? '5%' : '20%',
    });
  return columns;
}
